import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

/** Maps legacy Btn type to MUI variant and color. */
function mapVariant(type?: string): Pick<ButtonProps, 'variant' | 'color'> {
  switch (type) {
    case 'primary':
      return { variant: 'contained', color: 'primary' };
    case 'outline-primary':
      return { variant: 'outlined', color: 'primary' };
    case 'outline-secondary':
      return { variant: 'outlined', color: 'secondary' };
    case 'danger':
      return { variant: 'contained', color: 'error' };
    case 'link':
      return { variant: 'text' };
    case 'light':
      return { variant: 'outlined' };
    default:
      return { variant: 'outlined', color: 'primary' };
  }
}

function mapSize(size?: 'xs' | 'sm' | 'lg'): ButtonProps['size'] {
  if (size === 'lg') return 'large';
  return 'small';
}

export interface BtnLinkProps {
  readonly to: string;
  readonly size?: 'xs' | 'sm' | 'lg';
  readonly openInNewTab?: boolean;
  readonly target?: any;
  readonly type?: string;
  readonly icon?: React.ReactNode;
  readonly children?: React.ReactNode;
  readonly className?: string;
  readonly style?: React.CSSProperties;
  readonly width?: string;
  readonly 'data-cy'?: string;
}

/** Button styled as a link; forwards ref so it can be used inside MUI Tooltip. */
export const BtnLink = React.forwardRef<HTMLAnchorElement, BtnLinkProps>((props, ref) => {
  const { to, size, openInNewTab, type, icon, children, className, style, width, ...rest } = props;
  const { variant, color } = mapVariant(type);

  return (
    <Button
      ref={ref as any}
      component={Link}
      to={to}
      target={openInNewTab ? '_blank' : undefined}
      size={mapSize(size)}
      variant={variant}
      color={color as any}
      startIcon={icon}
      className={className}
      style={style}
      sx={width ? { minWidth: width } : undefined}
      {...rest}
    >
      {children}
    </Button>
  );
});
BtnLink.displayName = 'BtnLink';
